import classnames from 'classnames';
import React from 'react';
import DayPicker from 'react-day-picker';
import useBaseStyles from './base-styles';

const StyledDayPicker = React.forwardRef((props, ref) => {
  const classes = useBaseStyles();
  return <DayPicker className={classnames(classes.root, props.className)} ref={ref} {...props} />;
});

export default StyledDayPicker;
